import SVGLogo from 'images/lune-logo.svg?react'

const SVGLuneLogo = () => {
    return <SVGLogo width={96} />
}

export default SVGLuneLogo
